import * as actionTypes from 'actions';

const initialState = {
    Loading: false,
    workspaceAccessList: [],
  
    workspaceAccessRecord:[],
    validation_error: "",
    redirect_to_list: false,
    showDeleteModel: false,
    showUpdateForm: false,
    showViewPage: false,
}

const WorkspaceAccessReducer = (state = initialState, action) => {
    switch (action.type) {
       
    case actionTypes.WORKSPACE_ACCESS_REQUEST:
        return {
          ...state,
          Loading: true,
          validation_error: "",
          redirect_to_list: false,
        }
    case actionTypes.WORKSPACE_ACCESS_SERVER_SUCCESS:
        return {
          ...state, 
          Loading: false,
          redirect_to_list: false,
          validation_error: "",
          showUpdateForm: false,
          showViewPage: false,
          workspaceAccessRecord: [],
        }    
    case actionTypes.WORKSPACE_ACCESS_SUCCESS:
        return {
          ...state, 
          Loading: false,
          redirect_to_list: false,
          validation_error: "",
          workspaceAccessList: action.workspaceAccessList,
          showUpdateForm: false,
          showViewPage: false,
          workspaceAccessRecord: [],
        }
    
    case actionTypes.WORKSPACE_ACCESS_GET_SUCCESS:
        return {
            ...state, 
            Loading: false,
            redirect_to_list: false,
            workspaceAccessRecord: action.record,
            showUpdateForm: (action.actionType === 'update')? true:false,
            showViewPage: (action.actionType === 'view')? true:false
        }    
    case actionTypes.WORKSPACE_ACCESS_VALIDATION_ERROR:
        return {
            ...state,
            Loading: false,
            redirect_to_list: false,
            validation_error: action.validation_error,
        } 
    case actionTypes.HIDE_WORKSPACE_ACCESS_FIELD_VALIDATION_ERROR:
        if(state.validation_error && state.validation_error[action.feild_key])
            delete state.validation_error[action.feild_key]
        return {
            ...state,
            Loading: false,
            redirect_to_list: false,
            validation_error: action.validation_error,
            
        } 
    case actionTypes.REDIRECT_TO_WORKSPACE_ACCESS_LIST:
        return {
            ...state,
            redirect_to_list: true,
            showUpdateForm: false,
            showViewPage: false,
            validation_error: '',
            workspaceAccessRecord: [],
        }
    default:
        return state;
    }
}

export default WorkspaceAccessReducer;